module.exports = __webpack_public_path__ + "img/about.6aa70cc8.png";